<template>
	<section class="page">
		<el-tabs v-model="activeName">
			<el-tab-pane label="活动管理" name="list">
				<div class="content-box">
					<div class="operator">
						<div class="operator-col">
							<el-button size="mini" type="primary" @click="handleCreate()" v-loading="loadings.create">新建</el-button>
						</div>
						<div class="operator-col">
							<el-input
								size="mini"
								v-model="filterTableSearch"
								placeholder="商品名"
								suffix-icon="el-icon-search"
								clearable
							></el-input>
						</div>
					</div>
					<curd-table
						ref="listTable"
						:data-model="editorDataModel"
						:fields="tableFields"
						@doedit="handleEdit($event)"
						:search-filter="filterTableSearch"
						:sort-by="{ sortKey: 'first', sortOrder: 'asc' }"
					>
						<template slot="listOp" slot-scope="scope">
							<el-button type="text" size="mini" @click="handleEdit(scope.row._id)">编辑</el-button>
							<el-button type="text" size="mini" @click="goActiveInfo(scope.row._id)">详情</el-button>
						</template>
					</curd-table>
				</div>
			</el-tab-pane>
		</el-tabs>
		<editor
			:show.sync="editorVisible"
			:data-model-name="editorDataModel"
			:record-id="editorId"
			:fields="editorFields"
			@change="handleEdited($event)"
			v-if="editorVisible"
		></editor>
	</section>
</template>

<script>
import CurdPage from "@/mixins/CurdPage.js";
import Filters from "@/mixins/Filters.js";

export default {
	mixins: [CurdPage, Filters],

	data() {
		return {
			editorDataModel: "Active",
			tableFields: [
				{
					name: "brand",
					sortable: "custom",
				},
				{
					name: "name",
					sortable: "custom",
				},
				{
					name: "price",
					sortable: "custom",
				},
				{
					name: "stores",
					sortable: "custom",
				},
				{
					name: "type",
					sortable: "custom",
				},
				{
					name: "status",
					sortable: "custom",
				},
				{
					name: "publish_at",
					sortable: "custom",
				},
				{
					name: "begin_at",
					sortable: "custom",
				},

				{
					name: "open_at",
					sortable: "custom",
				},
				{
					name: "sale_at",
					sortable: "custom",
				},
				{
					name: "is_published",
					sortable: "custom",
				},
			],
			editorFields: [
				{
					name: "brand",
					rules: ["required"],
					width: "100%",
					col: 6,
				},
				{
					name: "name",
					rules: ["required"],
					width: "100%",
					col: 6,
				},
				{
					name: "price",
					rules: ["required"],
					width: "100%",
					col: 6,
				},

				{
					name: "type",
					col: 6,
				},
				{
					name: "stores",
					col: 12,
				},
				{
					name: "publish_at",
					col: 6,
					params: {
						type: "ts",
					},
				},
				{
					name: "begin_at",
					col: 6,
					params: {
						type: "ts",
					},
				},
				{
					name: "end_at",
					col: 6,
					params: {
						type: "ts",
					},
				},
				{
					name: "open_at",
					col: 6,
					params: {
						type: "ts",
					},
				},
				{
					name: "sale_at",
					col: 6,
					params: {
						type: "ts",
					},
				},
			],
		};
	},
	methods: {
		refreshTables() {
			this.refreshTable("listTable");
		},
		handleDelete(id) {
			this.loadings.main = true;
			this.$confirm("将永久删除该条目, 是否继续?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					const url = `/curd/do_delete/product_color/${id}`;

					this.$axios
						.post(url, { id: id })
						.then(json => {
							this.$message({
								type: "success",
								message: "删除成功!",
							});
							this.loadings.main = false;
							this.refreshTable("listTable");
							this.refreshTable("inputListTable");
						})
						.catch(json => {
							this.loadings.main = false;
							this.$message.error(json.data.msg);
						});
				})
				.catch(() => {
					this.loadings.main = false;

					this.$message({
						type: "info",
						message: "已取消删除",
					});
				});
		},
		handleEdit(id) {
			const { href } = this.$router.resolve({
				name: "Active-Edit",
				params: {
					id: id,
				},
			});
			window.open(href, "_blank");
		},
		handleEdited(data) {
			this.$router.push({
				name: "Active-Edit",
				params: {
					id: data._id,
				},
			});
		},
		goActiveInfo(id) {
			const { href } = this.$router.resolve({
				name: "Active-Info",
				params: {
					id: id,
				},
			});
			window.open(href, "_blank");
		},
	},
};
</script>
<style lang="scss" scoped></style>
